import { LoadingButton, Tooltip } from '@ingrid/luterkort-react';

import { ConditionalWrapper } from '~src/components/ConditionalWrapper/ConditionalWrapper';
import { LocalizationKey, useTranslation } from '~src/i18n/use-translation';

import { useConfiguratorContext } from './configurator-context';

interface Props {
  i18nKey: LocalizationKey;
}

export function RunTestButton({ i18nKey }: Props) {
  const { run, disableRunReason, isRunning } = useConfiguratorContext();
  const { t } = useTranslation();

  return (
    <ConditionalWrapper
      when={!!disableRunReason}
      wrapper={c => (
        <Tooltip content={disableRunReason}>
          <div>{c}</div>
        </Tooltip>
      )}
    >
      <LoadingButton loading={isRunning} onClick={run} disabled={!!disableRunReason}>
        {t(i18nKey)}
      </LoadingButton>
    </ConditionalWrapper>
  );
}
